import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { EditBeneficiaryForm } from 'local/components'
import { Button, ContentLoader, Input, Margin, Text } from 'shared/components'

import * as styles from './styles'

const BeneficiaryUpdateComponent = ({
  onSubmit,
  getBeneficiaryInfoById,
  getLinkForBeneConfirmSignUp,
  beneficiaryId,
}) => {
  const [initialValues, setInitialValues] = useState('')
  const [link, handleLinkGenerate] = useState('')
  useEffect(() => {
    const fetchData = async () => {
      const beneficiary = await getBeneficiaryInfoById(beneficiaryId)
      setInitialValues(beneficiary)
    }

    fetchData()
  }, [])

  const handleClickGenerateLink = async () => {
    const link = await getLinkForBeneConfirmSignUp(
      initialValues.preRegistrationId
    )
    handleLinkGenerate(link)
  }

  return initialValues ? (
    <>
      <EditBeneficiaryForm
        header="Update Beneficiary"
        onSubmit={onSubmit}
        initialValues={initialValues}
      />
      <Margin top={2} bottom={3} left={2}>
        <Text size={16} bold>
          Generate SignUp Confirm Link
        </Text>
      </Margin>
      <Margin top={2} bottom={3} left={2}>
        <Text size={16} bold>
          Pre Registration Id: {initialValues.preRegistrationId}
        </Text>
      </Margin>
      <Margin top={2} bottom={2} left={2}>
        <Input value={link} placeholder="Generate Link first..." />
      </Margin>
      <Margin left={2} bottom={3}>
        <Button green="true" medium onClick={handleClickGenerateLink}>
          Generate Link
        </Button>
      </Margin>
    </>
  ) : (
    <div css={styles.loaderWrapper}>
      <ContentLoader loading={true} />
    </div>
  )
}

BeneficiaryUpdateComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  getLinkForBeneConfirmSignUp: PropTypes.func.isRequired,
  getBeneficiaryInfoById: PropTypes.any,
  beneficiaryId: PropTypes.any,
}

export default BeneficiaryUpdateComponent
